import { Box } from '@chakra-ui/react';
import React from 'react';
import PoojaTable from './components/PoojaTable';

export default function PoojaManagement() {
  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <PoojaTable />
    </Box>
  );
}
